import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService, CustomModalService } from '../_services/index';
import { Subscription } from 'rxjs/Subscription';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

	constructor(
		private router: Router,
		public auth: AuthenticationService,
		private modal: CustomModalService
	) {}

	ngOnInit() {}

	goHome() {
		const link = ['/dashboard'];
		this.router.navigate(link);
	}

	logout() {
		this.modal.confirmModal({
			title: 'Logout',
			message: 'Are you sure you want to log out?',
			size: 'tiny'
		}, (res) => {
			if (res) {
				this.auth.logout();
			} else {
				console.log('Modal cancelled');
			}
		});
	}
}
